import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { auth } from './modules/auth';
import { contact } from './modules/contact';
import { tag } from './modules/tag';
import { emailTemplate } from './modules/emailTemplate';
import { campaign } from './modules/campaign';
import { emailLog } from './modules/emailLog';
import { smsTemplate } from './modules/smsTemplate';
import { sms } from './modules/sms';
import { smsCampaign } from './modules/smsCampaign';
import { contractTemplate } from './modules/contractTemplate';
import { contract } from './modules/contract';
import { school } from './modules/school';
import { user } from './modules/user';
import { automation } from './modules/automation';
import { survey } from './modules/survey';
import { dashboard } from './modules/dashboard';
import { navbarConfig } from './modules/navbarConfig';
import { notification } from './modules/notification';
import { integration } from './modules/integration';

Vue.use(Vuex);

export const createStore = () => {
  return new Vuex.Store({
    state: { brand: 'TransitionCRM' },
    getters: {},
    mutations: {},
    actions: {},
    modules: {
      auth,
      contact,
      tag,
      emailTemplate,
      campaign,
      emailLog,
      smsTemplate,
      sms,
      smsCampaign,
      contractTemplate,
      contract,
      school,
      user,
      automation,
      survey,
      dashboard,
      navbarConfig,
      notification,
      integration,
    },
    plugins: [createPersistedState({ paths: ['auth'] })],
  });
};

const store = createStore();
export default store;
